.head {
  margin: 4px 4px 4px;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.01em;
}

.intro {
  margin: 0 4px 4px;
  color: var(--muted);
  font-size: 14px;
  line-height: 1.4;
}

.card {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0;
  overflow: hidden;
  text-align: left;
  color: inherit;
  font: inherit;
  background: var(--surface);
  border: 1px solid var(--card-border);
  border-radius: var(--r-lg);
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.image {
  display: block;
  width: 100%;
  aspect-ratio: 16 / 9;
  object-fit: cover;
  background: var(--surface-sunken);
}

.cardBody {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 14px var(--pad) 16px;
}

.title {
  font-size: 18px;
  font-weight: 700;
}

.meta {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  font-size: 14px;
}

.muted {
  color: var(--muted);
}

.mine {
  font-weight: 600;
  color: var(--warn);
}

.chip {
  align-self: flex-start;
  padding: 4px 10px;
  border-radius: 999px;
  background: var(--accent-wash);
  font-size: 12px;
  color: var(--ink-soft);
}

.stats {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
}

.stat {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 12px;
  background: var(--surface);
  border: 1px solid var(--card-border);
  border-radius: var(--r-md);
}

.statValue {
  font-size: 20px;
  font-weight: 700;
}

.statLabel {
  font-size: 12px;
  color: var(--muted);
}

.section {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 16px;
  background: var(--surface);
  border: 1px solid var(--card-border);
  border-radius: var(--r-lg);
}

.sectionTitle {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.tickets {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.ticket {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 10px 12px;
  border: 1px dashed rgb(255 159 10 / 45%);
  border-radius: var(--r-sm);
}

.ticketNo {
  font-family: var(--mono);
  font-size: 15px;
  font-weight: 600;
  color: var(--warn);
}

.voided {
  opacity: 0.45;
  text-decoration: line-through;
}

.row {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  font-size: 14px;
}

.text {
  margin: 0;
  font-size: 14px;
  line-height: 1.45;
  color: var(--ink-soft);
  white-space: pre-line;
  overflow-wrap: anywhere;
}

.win {
  padding: 16px;
  border-radius: var(--r-lg);
  border: 1px solid rgb(255 159 10 / 45%);
  background: var(--warn-wash);
}

.winTitle {
  margin: 0 0 6px;
  font-size: 19px;
  font-weight: 700;
  color: var(--warn);
}

.mono {
  font-family: var(--mono);
}

.note {
  margin: 0;
  font-size: 12px;
  line-height: 1.35;
  color: var(--muted);
}
